module.exports = __webpack_public_path__ + "img/join.d516a15f.png";